import React from 'react'
import { useSelector } from 'react-redux'

import { BarChart } from '../../../../components/Charts/BarChart'
import StatisticIntervalSelect from '../../../common/Statistic/StatisticIntervalSelect'
import GridElementContainer from '../../../../components/pages/Statistics/StatisticsContent/GridElementContainer'
import ErrorBoundary from '../../../../components/Shared/ErrorBoundary'

import { selectStudentStats } from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { studentStatsDatasets } from '../../../../constants'

const ClassesGraphic = ({ interval, onIntervalChange }) => {
  const studentStats = useSelector(selectStudentStats)

  return (
    <GridElementContainer title="Classes Graphic" className="!mt-4">
      <div className="py-2 w-full">
        <div className="w-full bg-[#FEEBDD] rounded">
          <div className="w-full flex justify-between flex-wrap flex-col md:flex-row items-center">
            <div className="flex items-center justify-between w-full mb-[15px]">
              <div className="flex gap-[18px] items-center">
                {studentStatsDatasets.map((studentStatsDataset) => {
                  return (
                    <div key={`stat-${studentStatsDataset.key}`} className="flex items-center">
                      <div
                        style={{ backgroundColor: studentStatsDataset.color }}
                        className="w-[20px] h-[20px] rounded-[6px] border-[1px] border-[#D0D5DD]"
                      />

                      <span className="font-medium text-sm text-primary-100 ml-[8px]">
                        {studentStatsDataset.label}
                      </span>
                    </div>
                  )
                })}
              </div>

              <StatisticIntervalSelect interval={interval} onIntervalChange={onIntervalChange} />
            </div>
          </div>

          <div className="w-full">
            <div
              className="w-100 px-2.5 py-3 bg-[#FFF5EE] rounded-md !border border-[#FFCA84]"
              style={{ height: '206px' }}
            >
              <ErrorBoundary>
                <BarChart
                  stats={
                    interval === 'Month'
                      ? studentStats?.stats?.last_month
                      : interval === 'Year'
                        ? studentStats?.stats?.last_12_months
                        : studentStats
                  }
                  datasets={studentStatsDatasets}
                  interval={interval}
                />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </GridElementContainer>
  )
}

export default ClassesGraphic
